//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export enum CannedDates {
    Today = 0,
    Tomorrow = 1,
    Yesterday = 2,
    LastWeek = 3,
    ThisWeek = 4,
    NextWeek = 5,
    LastMonth = 6,
    ThisMonth = 7,
    NextMonth = 8,
    Prev30Days = 9,
    Prev60Days = 10,
    Next30Days = 11,
    Next60Days = 12,
    Prev90Days = 13,
    Next90Days = 14,
    Prev180Days = 15,
    Next180Days = 16,
    LastYear = 17,
    ThisYear = 18,
    NextYear = 19,
    All = 20,
}

export enum ClinicalReportType {
    Regular = 0,
    FullRecord = 1,
    Emergency = 2,
    Release = 3,
}

export enum DeleteReasonEntityType {
    DynamicForm = 1,
    StaticForm = 2,
    Document = 3,
    Task = 4,
    ImagingLabRequest = 5,
    SapphireLabRequest = 6,
    LabResult = 7,
    Waitlist = 8,
    DentalTreatment = 9,
    DentalCondition = 10,
    DentalToothNote = 11,
    Vital = 12,
}

export enum DeleteReasonType {
    Form = 1,
    Document = 2,
    Task = 3,
    LabOrderRequest = 4,
    LabResult = 5,
    Waitlist = 6,
    Vital = 7,
}

export enum FormResponseShowType {
    Standard = 0,
    Redacted = 1,
    AnswersOnly = 2,
}

/** Descriptions the permission types */
export enum PermissionType {
    CreatePatientSpecificOrder = 100,
    ModifyPatientSpecificOrder = 101,
    CreateStockOrder = 102,
    ModifyStockOrder = 103,
    CreateLabAndVitalOrder = 104,
    ModifyLabAndVitalOrder = 105,
    CanSubmitRefill = 106,
    CanReorder = 107,
    CanCreateMultipleStockOrderForms = 108,
    CanModifyOrRenameMultipleStockOrderForms = 109,
    CanDeleteMultipleStockOrderForms = 110,
    CanDiscontinueOrder = 111,
    CanDiscontinueSignoffOrder = 112,
    CanCreateProtocols = 113,
    CanModifyProtocols = 114,
    CanDeleteProtocols = 115,
    CanAccessScriptLookup = 116,
    CanManageImmunizationForms = 117,
    CanOrderPatientLabs = 118,
    AllowOrdersWithoutDiagnosis = 119,
    CanOrderMultipleStockOnly = 120,
    CanOrderDiagnosticImaging = 121,
    CanEnterStandaloneLabResults = 122,
    CanAccessEPCSQueueAndPrintOrders = 123,
    CanRenewVitalOrders = 124,
    CanRenewMedOrders = 125,
    CanViewSurescriptsMessageQueue = 126,
    CanViewGpiSubMessages = 127,
    CanManagePatientInventory = 200,
    CanManageStockInventory = 201,
    CanCheckInItems = 202,
    CanReturnItems = 203,
    CanVerifyControlledStock = 204,
    CanDestroyControlledStock = 205,
    CanViewShipments = 206,
    CanAccessVaccineInventory = 207,
    CanVerifyOrder = 300,
    CanPerformApprovalsofConvenience = 301,
    CanApprovePatientOrder = 302,
    CanApproveStockOrder = 303,
    CanPerformStockDoubleCheck = 304,
    CanApproveNonFormularyOrder = 305,
    CanRemoveExceptions = 306,
    CanProvideClarifications = 307,
    CanReviewOrder = 308,
    CanQuickNFApproval = 309,
    CanShowRegionalQueueOption = 310,
    CanApproveVitalOrder = 311,
    CanApproveVitalResult = 312,
    CanAccessPrepList = 400,
    CanPerformMedPass = 401,
    CanAccessTrashedSchedules = 402,
    CanPerformTarPass = 403,
    CanAddPatients = 500,
    CanModifyPatients = 501,
    CanMergePatients = 502,
    CanSplitPatients = 503,
    CanTransferPatients = 504,
    CanAccessPatientChart = 505,
    CanAccessPatientChartNotes = 506,
    CanAccessPatientDocuments = 507,
    CanAccessPatientImmunizations = 508,
    CanAccessPatientLabReports = 509,
    CanAllowPatientDocumentSignoff = 510,
    CanAllowPatientDocumentAdd = 511,
    CanAllowPatientLabResultsSignoff = 512,
    CanDeletePatientDocuments = 513,
    CanAllowPatientFormResponseSignoff = 514,
    CanAllowRevokeKOP = 515,
    CanAllowReInstateKOP = 516,
    CanAllowPatientOMHLevelEditing = 517,
    CanAddModifyPatientFormResponses = 518,
    CanDeletePatientFormResponses = 519,
    CanViewPatientActivityRestrictions = 521,
    CanModifyPatientActivityRestrictions = 522,
    CanViewPatientSummaryTab = 523,
    CanDeleteInvalidVitalProblemEntry = 524,
    CanModifySecondaryPatientIdentifier = 525,
    CanAddPatientProblems = 526,
    CanResolvePatientProblems = 527,
    CanAddVitalLabsResultsFromPatientChart = 528,
    CanAllowChangeElevatedDemographics = 529,
    CanAccessVitalReviewQueue = 530,
    CanReviewVitalResults = 531,
    CanAccessIntakeProcessingQueue = 532,
    PermissionBenefitsApplication = 534,
    CanAccessWithdrawlPatientAssessment = 535,
    CanAddWithdrawlPatientAssessment = 536,
    CanFollowupWithdrawlPatientAssessments = 537,
    CanFollowupVitalFollowupQueue = 539,
    CanApprovePatientActivityRestriction = 540,
    CanFollowPatientActivityRestriction = 541,
    CanAddFormResponsesToReleasedPatients = 542,
    CanAddPatientAlerts = 543,
    CanAddBlockingAlert = 544,
    CanViewLockedPatientChart = 545,
    CanDeletePatientLabReports = 546,
    CanAccessPatientChartInEmergency = 547,
    CanArchivePatientAlerts = 548,
    CanRemoveBlockingAlert = 549,
    CanAccessEHRQueues = 550,
    CanAutoApproveActivityRestriction = 551,
    CanAllowPatientDocumentUpdate = 552,
    CanLockPatientChart = 553,
    CanUnlockPatientChart = 554,
    CanDeleteVaccineAdministration = 555,
    CanRenewPatientForms = 556,
    CanAccessReporting = 600,
    CanCreateUsers = 700,
    CanModifyUsers = 701,
    CanResetPasswords = 702,
    CanLockAccounts = 703,
    CanUnlockAccounts = 704,
    CanCreateRolePermissions = 705,
    CanModifyRolePermissions = 706,
    CanDeleteRole = 707,
    CanAccessFormActionViewer = 708,
    CanViewInactiveAccounts = 709,
    CanChangeUserNames = 710,
    CanModifyFacility = 803,
    CanViewFiles = 804,
    CanDeleteFiles = 805,
    CanAccessTasking = 900,
    CanAccessPatientChartTasking = 901,
    CanAddTasking = 902,
    CanDeleteTasks = 903,
    CanCompleteTasking = 904,
    CanEditTaskingStatus = 905,
    CanViewGlobalCalendar = 906,
    CanAccessFacilityTaskTemplates = 907,
    CanBulkUpdateAssignedTasks = 908,
    CanBulkUpdateAllTasks = 909,
    CanEditExistingTask = 910,
    CanDeleteTaskingStatus = 911,
    CanEditExistingTaskTags = 912,
    CanAccessWaitlist = 913,
    CanCreateTaskTemplates = 914,
    CanDeleteTaskTemplates = 915,
    CanDeleteWaitlists = 916,
    CanCompleteWaitlists = 917,
    CanDeleteDentalTreatments = 918,
    CanAccessDentalReadOnly = 919,
    CanCreateFacilityExportReports = 920,
    ViewConsultAppointmentCalendar = 921,
    CanAccessMessaging = 1000,
    CanAccessMessagingReadOnly = 1001,
    CanCreateModifyConsultations = 1100,
    CanViewConsultations = 1101,
    CanScheduleConsultsAndFollowups = 1102,
    CanScheduleMultipleAppointments = 1104,
    CanPreScreenConsults = 1105,
    CanDCCloseConsults = 1106,
    CanAccessTBTesting = 1200,
    CanReviewTBTests = 1201,
    CanCreateModifyTBTests = 1202,
    ElevatedTbPrivileges = 1203,
    CanAddRemoveHotlistPatient = 1204,
    CanAddRemoveHotlistPatientComment = 1205,
    CanViewPatientMessages = 1300,
}

/** Make sure if you add a new date option, the value is in the Diamond.EMAR.Common.Utility._SetDate function. */
export enum TaskFilterCannedDates {
    DefaultValue = 0,
    Today = 1,
    Tomorrow = 2,
    Yesterday = 3,
    LastWeek = 4,
    ThisWeek = 5,
    NextWeek = 6,
    LastMonth = 7,
    ThisMonth = 8,
    NextMonth = 9,
    Past30Days = 10,
    Past60Days = 11,
    Past90Days = 12,
    Past180Days = 13,
    Next30 = 14,
    Next60 = 15,
    Next90 = 16,
    Next180 = 17,
    LastYear = 18,
    ThisYear = 19,
    NextYear = 20,
    All = 21,
}

export interface ClinicalSummaryLogCriteria {
    Id: number;
    Name?: string | undefined;
    PatID?: string | undefined;
    FacID?: string | undefined;
    UserID?: string | undefined;
    UserName?: string | undefined;
    showImmunizations: boolean;
    showMedications: boolean;
    showInactiveMedications: boolean;
    showProblemList: boolean;
    showInactiveProblems: boolean;
    showLabResults: boolean;
    showFullLabResults: boolean;
    showSpecificLabResults: boolean;
    /** Leaving this in for historical reasons.  Will be converted to the new LabResultsAfter. */
    LastXLabMonths?: string | undefined;
    LabResultsAfter?: string | undefined;
    LabResultsTo?: string | undefined;
    showMHUChartSummary: boolean;
    SelectedMHUDate?: string | undefined;
    showVitals: boolean;
    showNotes: boolean;
    ReportNotes?: string | undefined;
    NotesAfter?: string | undefined;
    NotesTo?: string | undefined;
    MedicationsAfter?: string | undefined;
    MedicationsTo?: string | undefined;
    VitalsAfter?: string | undefined;
    VitalsTo?: string | undefined;
    SelectedSpecificLabReportsForPrinting?: string | undefined;
    SelectedSpecificFormResponsesForPrinting?: string | undefined;
    SelectedFormResponseTags?: string | undefined;
    SelectedFormResponseGroups?: string | undefined;
    SelectedPatDocTags?: string | undefined;
    SelectedPatDocGroups?: string | undefined;
    SelectedFormResponseTagsExclude?: string | undefined;
    SelectedFormResponseGroupsExclude?: string | undefined;
    SelectedPatDocTagsExclude?: string | undefined;
    SelectedPatDocGroupsExclude?: string | undefined;
    ShowReleasedMeds: boolean;
    MhuDescription?: string | undefined;
    showPatientMessages: boolean;
    MessagesAfter?: string | undefined;
    MessagesTo?: string | undefined;
    showFormResponses: boolean;
    showRedactedResponses: boolean;
    showSpecificFormResponses: boolean;
    FormShowType: FormResponseShowType;
    showConsultDocs: boolean;
    showRestrictions: boolean;
    showDocuments: boolean;
    includeAllUploadedPDFs: boolean;
    PatientDocUploadedAfter?: string | undefined;
    PatientDocUploadedTo?: string | undefined;
    patientDocIncludedOption: number;
    showTBReport: boolean;
    TBAfterDate?: string | undefined;
    TBToDate?: string | undefined;
    ConsultDocsAfterDate?: string | undefined;
    ConsultDocsToDate?: string | undefined;
    saveReportAsPatientDoc: boolean;
    getFullRecord: boolean;
    isEmergencyReport: boolean;
    isReleaseReport: boolean;
    generateCCD: boolean;
    generateDentalReport: boolean;
    Payload?: string | undefined;
    StatusFlag?: string | undefined;
    SelectedSpecificLabReports?: LabReportHeader[] | undefined;
    SelectedFormResponseTagsVue?: Tag[] | undefined;
    SelectedFormResponseGroupsVue?: PatientDocumentCategories[] | undefined;
    SelectedPatDocTagsVue?: Tag[] | undefined;
    SelectedPatDocGroupsVue?: PatientDocumentCategories[] | undefined;
    SelectedFormResponseTagsExcludeVue?: Tag[] | undefined;
    SelectedFormResponseGroupsExcludeVue?: PatientDocumentCategories[] | undefined;
    SelectedPatDocTagsExcludeVue?: Tag[] | undefined;
    SelectedPatDocGroupsExcludeVue?: PatientDocumentCategories[] | undefined;
    SelectedMHUDateVue?: KeyValuePairOfIntegerAndString[] | undefined;
    PresetCannedDate: CannedDates;
    showPatientTasks: boolean;
    TasksAfter?: string | undefined;
    TasksTo?: string | undefined;
    SelectedTaskStatus?: string | undefined;
}

export interface LabReportHeader {
    PatientDocumentNotesJSON?: string | undefined;
    LabOrderID: number;
    SignoffID: number;
    SignoffDate: Date;
    SignoffBy?: string | undefined;
    SignoffNeeded: boolean;
    isReferred: boolean;
    SpecimenSourceDesc?: string | undefined;
    DocName?: string | undefined;
    DocID: number;
    FacID: number;
    FacilityName?: string | undefined;
    PatientName?: string | undefined;
    PatientLocation?: string | undefined;
    PatientDOB?: string | undefined;
    PatientIdentifier?: string | undefined;
    LabAccountID?: string | undefined;
    FillerID?: string | undefined;
    FillerIDDesc?: string | undefined;
    InsertedOn: Date;
    LabReportID: number;
    LastModified: Date;
    ObservationDateTime: Date;
    PatID: number;
    Placer?: string | undefined;
    ResultsReportedDateTime: Date;
    VendorID?: string | undefined;
    LabServiceID?: string | undefined;
    LabServiceDesc?: string | undefined;
    SetID: number;
    SpecimenReceivedDateTime: Date;
    SpecimenSourceCode?: string | undefined;
    ProviderID: number;
    ProviderName?: string | undefined;
    ProviderNameNoHTML?: string | undefined;
    HasAbnormalValues: boolean;
    IsWNLFlag: boolean;
    DC_BY?: string | undefined;
    DC_DATE: Date;
    DC_REASON_NOTE?: string | undefined;
    LabReportDescription?: string | undefined;
    SignOffCompleted: boolean;
    HasMultipleAttachments: boolean;
    NoPlacerFlag: boolean;
    AbnormalResultsJSON?: string | undefined;
    AbnormalResults?: LabResult[] | undefined;
    PatientDocumentNotes?: FormResponseNotes[] | undefined;
    CreatedBy?: string | undefined;
}

export interface LabResult {
    SIGNOFF_RESULTS?: string | undefined;
    SERVICE_TEXT?: string | undefined;
    SERVICE_UID?: string | undefined;
    PLACER?: string | undefined;
    FILLER?: string | undefined;
    SET_ID?: string | undefined;
    ObservationResultText?: string | undefined;
    ObservationResultID: number;
    ObservationDesc?: string | undefined;
    AbnormalFlags?: string | undefined;
    InsertedOn: Date;
    LabReportID: number;
    ModifiedOn: Date;
    ObservationCode?: string | undefined;
    ObservationResult?: string | undefined;
    ProducerID?: string | undefined;
    ReferenceRange?: string | undefined;
    SetID: number;
    UnitsOfMeasure?: string | undefined;
    ResultNotes?: string | undefined;
    PastLabResults?: LabResult[] | undefined;
    ObservedOn: Date;
    ObservationResultCleanText?: string | undefined;
}

export interface FormResponseNotes {
    ID: number;
    Description?: string | undefined;
    CategoryName?: string | undefined;
    CreatedBy?: string | undefined;
    CreatedOn: Date;
    CreatedOnDate?: string | undefined;
}

export interface Tag {
    ID: number;
    Name?: string | undefined;
    FacGrpID: number;
    FacID: number;
    AddedOn: Date;
    AddedBy: number;
    AddedByName?: string | undefined;
    Deleted: boolean;
    ModifiedOn: Date;
    ModifiedBy: number;
    ModifiedByName?: string | undefined;
}

export interface PatientDocumentCategories {
    DocumentCategoryID: number;
    DocumentCategoryName?: string | undefined;
    Active: boolean;
}

export interface KeyValuePairOfIntegerAndString {
    Key: number;
    Value?: string | undefined;
}

export interface ClinicalSummaryPayload {
    Id: number;
    Payload?: string | undefined;
    StatusFlag?: string | undefined;
    CreateDate: Date;
    FAC_ID: number;
    DNAME?: string | undefined;
    USERNAME?: string | undefined;
    PAT_ID: number;
    PatientName?: string | undefined;
    ReportType?: string | undefined;
}

export interface ClinicalSummaryTemplate {
    Id: number;
    Payload?: string | undefined;
    StatusFlag?: string | undefined;
    CreateDate: Date;
    FAC_ID: number;
    DNAME?: string | undefined;
    USERNAME?: string | undefined;
    PAT_ID: number;
    PatientName?: string | undefined;
    ReportType?: string | undefined;
    PresetCannedDate: CannedDates;
}

export interface ConsultClaim {
    ID: number;
    patID: number;
    ConsultRequestID: number;
    ConsultApptID: number;
    CreatedOn?: string | undefined;
    CreatedBy: number;
    Status?: string | undefined;
    ServiceFromDate: Date;
    ServiceToDate: Date;
    SendOutFac: number;
    BillingProvider?: string | undefined;
    ClaimNumber?: string | undefined;
    ProcedureCode?: string | undefined;
    DRG?: string | undefined;
    ClaimAmount?: string | undefined;
    ContractualAdjustment?: string | undefined;
    ClaimReceived: Date;
    ClaimAdjudicated?: string | undefined;
    Carrier?: string | undefined;
    MemberID?: string | undefined;
    GroupID?: string | undefined;
    InsuranceType?: string | undefined;
    LastModifiedOn: Date;
    LastModifiedBy: number;
    AllowedAmount?: string | undefined;
    InsurancePayment?: string | undefined;
    PTResp?: string | undefined;
    MedicaidCheck: boolean;
    PaidDate: Date;
}

export interface ContextMenuNode {
    ID: number;
    label?: string | undefined;
    parentID?: string | undefined;
    children?: ContextMenuNode[] | undefined;
    clickEvent?: string | undefined;
    SortOrder: number;
    /** This eventParameter is | delimited string that comes from the context menu table. */
    eventParameter?: string | undefined;
    disabled: boolean;
}

export interface DashboardAlert {
    AlertMessage?: string | undefined;
    AlertType?: string | undefined;
}

export interface DashboardMessages {
    MessageCount: number;
    Messages?: UserMessage[] | undefined;
}

export interface UserMessage {
    DateSent: Date;
    MessageBody?: string | undefined;
    MessageID: number;
    MessageType: UserMessageType;
    Priority: UserMessagePriority;
    ReplyToMessageID: number;
    SenderFirstName?: string | undefined;
    SenderID: number;
    SenderKeep: boolean;
    SenderLastName?: string | undefined;
    SenderMidName?: string | undefined;
    Subject?: string | undefined;
    ThreadRootMessageID: number;
    PatientID: number;
    SelectedRecipients?: number[] | undefined;
    SenderFullName?: string | undefined;
    PatientName?: string | undefined;
    SenderUserName?: string | undefined;
    MessageRecipients?: User[] | undefined;
    RecipientKept: boolean;
    RecipientReadDate: Date;
    FileAttachmentList?: PatientDocumentFile[] | undefined;
}

export enum UserMessageType {
    General = 1,
    Billing = 2,
    Inventory = 3,
    MAR = 4,
    MedPass = 5,
    Patient = 6,
    Queues = 7,
    Reporting = 8,
}

export enum UserMessagePriority {
    Normal = 1,
    Urgent = 2,
}

/** User DTO represents the details of a User */
export interface User {
    ProfileID?: number;
    DefaultLanndingPageId: number;
    /** Gets/Sets the ActiveFacilityID */
    ActiveFacilityID: number;
    /** Gets/Sets the ActiveFacilityID */
    ActiveFacilityName?: string | undefined;
    /** Gets\Sets Audit Log Id */
    AuditLogID: number;
    /** Gets/Sets the Email */
    Email?: string | undefined;
    /** Gets/Sets the FirstName */
    FirstName?: string | undefined;
    /** Gets/Sets the IsNeededNonFormularyAlerts */
    IsNeededNonFormularyAlerts: boolean;
    /** Gets/Sets the LastName */
    LastName?: string | undefined;
    /** Gets/Sets the MiddleName */
    MiddleName?: string | undefined;
    /** Gets/Sets the NewUserName */
    UserName?: string | undefined;
    /** Gets/Sets the Existing UserName */
    OldUserName?: string | undefined;
    MobilePhoneNumber?: string | undefined;
    /** Gets/Sets the Employee Number */
    EmployeeNumber?: string | undefined;
    /** Gets the Password */
    Password?: string | undefined;
    /** Gets/Sets the PrescriberID */
    PrescriberID: number;
    /** Gets/Sets the Prescriber Name */
    PrescriberName?: string | undefined;
    /** Gets/Sets the RegionID */
    RegionID: number;
    /** Gets/Sets the Prescriber Name */
    RegionName?: string | undefined;
    /** Gets/Sets the HighestApprovalTier */
    HighestApprovalTier: number;
    /** Gets/Sets the HighestApprovalTier */
    HighestApprovalTierName?: string | undefined;
    /** Gets/Sets whether the User Acoount Is Locked */
    IsLocked: boolean;
    /** Gets/Sets whether the User Is Pharmacist */
    IsPharmacist: boolean;
    /** Gets/Sets whether the User Is Internal */
    IsInternal: boolean;
    /** Gets/Sets whether the User DisableFormRespNotifications */
    DisableFormRespNotifications: boolean;
    /** Gets/Sets whether the User Is Multiregion */
    IsMultiregion: boolean;
    /** Gets/Sets whether the User wants to be prompted when switching between Facilities */
    DoNotPromptFacilitySwitch: boolean;
    /** Gets/Sets whether the User can default to Summary View in EHR */
    DefaultToSummaryView: boolean;
    /** Gets/Sets whether the User can default to the prescriber dashboard in EHR */
    DefaultDashboard: number;
    /** Gets/Sets Last event Type */
    LastEventID: EventType;
    /** User currently logged in */
    LoggedInUser?: string | undefined;
    AllowedSites?: KeyValuePairOfIntegerAndString[] | undefined;
    AllowedRegions?: KeyValuePairOfIntegerAndString[] | undefined;
    /** Gets / Sets whether password change has to be forced */
    ForcePasswordChange: boolean;
    /** gets / sets the userid. */
    LoggedInUserID: number;
    /** gets / sets the userid. */
    UserID: number;
    PasswordHash?: string | undefined;
    /** Gets the MedpassUserHash(password) for MedPass */
    MedpassUserHash?: string | undefined;
    /** User assigned roles for each facilty */
    FacRoles?: FacilityRoles[] | undefined;
    NonFormularyGroupIDs?: number[] | undefined;
    /** Gets or sets the last modified by id. */
    LastModifiedBy: number;
    /** Gets or sets the last modified by name. */
    LastModifiedByName?: string | undefined;
    /** Gets or sets the last modified date. */
    LastModifiedDate: Date;
    QueuesViewOnly: boolean;
    IsDisabled: boolean;
    FullName?: string | undefined;
    CompleteName?: string | undefined;
    DefaultOrderPrescriberID: number;
    CredentialID: number;
    isEPCSApproved: boolean;
    isEPCSLocked: boolean;
    isEPCSChangePending: boolean;
    DEAnumber?: string | undefined;
    DEAExpiration: Date;
    SSO_ENABLED: boolean;
    EPCSSerialNumber?: string | undefined;
    EPCSCurrentUserSetting: boolean;
    TwoFacType: TwoFacType;
}

/** List of Event types */
export enum EventType {
    Undefined = 0,
    None = 1,
    CreateOrder = 2,
    CreateStockOrder = 3,
    ModifyOrder = 4,
    ModifyStockOrder = 5,
    DiscontinueScript = 6,
    ApproveOrder = 7,
    DoubleCheckOrder = 8,
    ApproveNFOrder = 9,
    RejectOrder = 10,
    ExpireOrder = 11,
    ProcessOrder = 12,
    Verified = 13,
    CreateOrderFromCIPS = 14,
    ModifyOrderFromCIPS = 15,
    RejectOrderFromCIPS = 16,
    CancelOrderFromCIPS = 17,
    TransmittedToCIPS = 18,
    ApproveFill = 19,
    ApproveNFFill = 20,
    DoubleCheckFill = 21,
    PendingProcessing = 22,
    InitiateVoidRequest = 23,
    RejectFill = 24,
    Refill = 25,
    EnRoute = 26,
    CreateRole = 27,
    CreateUser = 28,
    CreateFill = 29,
    DeleteRole = 30,
    CreateFacility = 31,
    ModifyFacility = 32,
    SplitPatient = 33,
    ModifyUser = 34,
    CreatePatient = 35,
    ModifyPatient = 36,
    MergePatient = 37,
    CreateRegion = 38,
    ModifyRegion = 39,
    DeleteRegion = 40,
    ModifyRole = 41,
    MedpassResult = 42,
    MedpassIssueCreated = 43,
    CreateOTCData = 44,
    CreateVitals = 45,
    ModifyVitals = 46,
    AddLabel = 47,
    UpdateLabel = 48,
    AddPatientInventory = 49,
    UpdatePatientInventory = 50,
    AddStockInventory = 51,
    UpdateStockInventory = 52,
    ReturnedMedication = 53,
    DestroyedMedication = 54,
    ViewOrder = 55,
    ViewPatient = 56,
    CreatePatientFromCIPS = 57,
    ModifyPatientFromCIPS = 58,
    ApprovedOrder = 59,
    ApprovedNFOrder = 60,
    ApprovedAoCOrder = 61,
    RemoveException = 62,
    DiscontinueScriptFromCIPS = 63,
    CreateMultipleStockOrderForm = 64,
    ModifyMultipleStockOrderForm = 65,
    DeleteMultipleStockOrderForm = 66,
    SaveVitalsValue = 67,
    AddPatientATAStatus = 68,
    UpdatePatientATAStatus = 69,
    CreateMedpassSchedule = 70,
    ModifyOrderVitalLabRemoved = 71,
    ModifyOrderModifyVitalLab = 72,
    ResolvedMedPassIssue = 73,
    CreateFillFromCIPS = 74,
    ViewVital = 75,
    CancelOrderRejectedFromCIPS = 76,
    DiagnosisAdded = 77,
    DiagnosisResolved = 78,
    CreateFacilityDrugFromCIPS = 79,
    DeleteFacilityDrugFromCIPS = 80,
    ModifyFillFromCIPS = 81,
    TransferPatient = 82,
    CreateProtocol = 83,
    ModifyProtocol = 84,
    ReleaseMedications = 85,
    RevokeKOP = 86,
    CreatePatientDiagnosisFromCips = 87,
    ModifyPatientDiagnosisFromCips = 88,
    CreatePatientFromJMS = 89,
    ModifyPatientFromJMS = 90,
    CreateProtocolForm = 91,
    ModifyProtocolForm = 92,
    DeleteProtocolForm = 93,
    ProvideClarification = 94,
    DeclineClarification = 95,
    MedpassIssueUpdated = 96,
    CreatePatientFromInterface = 97,
    ModifyPatientFromInterface = 98,
    CreateOrderFromInterface = 99,
    ModifyOrderFromInterface = 100,
    RemoveReorder = 101,
    RemoveRefill = 102,
    ModifyPatientImageFromJMS = 103,
    AddPatientVisit = 104,
    ModifyPatientVisit = 105,
    ViewPatientVisit = 106,
    ViewPatientDocument = 107,
    ModifyPatientDocument = 108,
    AddPatientDocument = 109,
    TransferPatientFromJMS = 110,
    TransferPatientFromCIPS = 111,
    UpdatePatientNumberFromJMS = 112,
    SetMedicationHold = 113,
    RemoveMedicationHold = 114,
    ViewPatientImmunization = 115,
    EditPatientImmunization = 116,
    AddPatientImmunization = 117,
    DeletePatientImmunization = 118,
    AddVaccineLot = 119,
    EditVaccineLot = 120,
    DeleteVaccineLot = 121,
    ImmunizationRefusal = 122,
    DeletePatientRefusal = 123,
    UpdateStockInventoryAdministration = 124,
    SignoffPatientDocument = 125,
    SignoffLabsReport = 126,
    DisablePatientDocument = 130,
    DispensePerClientNFPolicy = 131,
    PatientDiagnosisDeleted = 132,
    PatientFormProgressLog = 133,
    DiscontinueSignoff = 134,
    AddPatientHousingStatus = 135,
    UpdatePatientHousingStatus = 136,
    UpdatePatientFromFormCapture = 137,
    SignEPCSOrder = 138,
    PrintPhysicallySignEPCSOrder = 139,
}

export interface FacilityRoles {
    /** Gets/Sets the Facility ID */
    FacilityID: number;
    /** Gets/Sets the Facility Name */
    FacilityName?: string | undefined;
    /** Assigned roles for current facility */
    AssignedRoles?: KeyValuePairOfIntegerAndString[] | undefined;
    /** Avaliable roles for current facility */
    AvaliableRoles?: KeyValuePairOfIntegerAndString[] | undefined;
}

export enum TwoFacType {
    Disabled = 0,
    Text = 1,
    Email = 2,
}

export interface PatientDocumentFile {
    PatientDocumentID: number;
    ID: number;
    FileSize: number;
    Description?: string | undefined;
    FileType?: string | undefined;
    DisplayFileName?: string | undefined;
    FileName?: string | undefined;
    FilePath?: string | undefined;
    CreatedBy?: string | undefined;
    DateCreated?: string | undefined;
    ModifiedBy?: string | undefined;
    LastModified?: string | undefined;
    Deleted: boolean;
    DownloadURL?: string | undefined;
    ECSObjectKeyPath?: string | undefined;
}

export interface DashboardReports {
    CustomReports?: CustomReports[] | undefined;
    Reports?: MenuItem[] | undefined;
    FavoriteReports?: MenuItem[] | undefined;
    FavoriteCustomReports?: CustomReports[] | undefined;
    Documents?: MenuItem[] | undefined;
    Websites?: MenuItem[] | undefined;
}

export interface CustomReports {
    ID: number;
    ReportName?: string | undefined;
    Name?: string | undefined;
    Description?: string | undefined;
    CategoryID: number;
    CategoryName?: string | undefined;
    ParameterList?: string | undefined;
    isPDFOutputEnabled: boolean;
    isExcelOutputEnabled: boolean;
    isDashboardReport: boolean;
    isPublicReport: boolean;
    FacilityList?: string | undefined;
    FacilityName?: string | undefined;
    FAC_GRP_ID: number;
    FacilityGroupName?: string | undefined;
    StoredProc?: string | undefined;
    isInactiveFlag: boolean;
    supportsExtraParams: boolean;
    UserList?: string | undefined;
    RoleList?: string | undefined;
    CreatedOn: Date;
    CreatedBy: number;
    DC_Date: Date;
    DC_By: number;
    ModifiedOn: Date;
    ModifiedBy: number;
    CannedDateValue?: string | undefined;
    FavoriteID: number;
    FavoriteDisplayName?: string | undefined;
    isFavorite: boolean;
    DownloadURL?: string | undefined;
    FavMenuID: number;
}

export interface MenuItem {
    MenuID: number;
    Title?: string | undefined;
    URL?: string | undefined;
    ParentID: number;
    CanDelete: boolean;
    FavoriteID: number;
}

export interface DashboardTasks {
    TaskCount: number;
    Tasks?: Tasks_Detail[] | undefined;
    Roles?: TaskRoles[] | undefined;
    Tags?: Tag[] | undefined;
    Status?: KeyValuePairOfIntegerAndString[] | undefined;
    StatusReasons?: KeyValuePairOfIntegerAndString[] | undefined;
    TaskTimes?: KeyValuePairOfIntegerAndString[] | undefined;
}

export interface Tasks_Detail {
    MasterTask?: Tasks | undefined;
    SpecificID?: string | undefined;
    TaskDate: Date;
    FormattedTaskDate?: string | undefined;
    PastDueFlag: boolean;
    Status?: string | undefined;
    StatusReasonID: number;
    StatusReasonDesc?: string | undefined;
    StatusReasonDescColor?: string | undefined;
    CompletedDate?: string | undefined;
    CompletedBy?: string | undefined;
    CompletedNote?: string | undefined;
    DateOfBirth?: string | undefined;
    /** Get/Set CompletedNotes */
    OMH?: string | undefined;
    ScheduleLinkURL?: string | undefined;
    showCheckmarkIcon: boolean;
    showBlueClockIcon: boolean;
    showAddFormIcon: boolean;
}

export interface Tasks {
    ID: number;
    FacilityID: number;
    PatientID: number;
    PatientName?: string | undefined;
    PatientLocation?: string | undefined;
    PatientNumber?: string | undefined;
    PatientStatus?: string | undefined;
    PatientAnniversaryDate?: string | undefined;
    PatientGender?: string | undefined;
    PatientRace?: string | undefined;
    Reason?: string | undefined;
    ReasonID: number;
    Category?: string | undefined;
    CategoryID: number;
    CategoryIDList?: string | undefined;
    UserIDList?: string | undefined;
    RoleIDList?: string | undefined;
    StartTime?: string | undefined;
    EndTime?: string | undefined;
    Priority: TaskPriority;
    PriorityDesc?: string | undefined;
    PriorityColor?: string | undefined;
    FrequencyType: TaskFrequencyType;
    Title?: string | undefined;
    RecurrenceDescription?: string | undefined;
    Tags?: Tag[] | undefined;
    Description?: string | undefined;
    ShortDescription?: string | undefined;
    Pattern?: string | undefined;
    /** OccurrenceCount is used to check if this is a one-time/immediate task.  If it is an immediate or one-time task, it will discontinue the task. */
    OccurrenceCount: number;
    UserList?: string | undefined;
    RoleList?: string | undefined;
    ExcludeWeekends: boolean;
    ExcludeHolidays: boolean;
    EndType?: string | undefined;
    EndDateType: EndDateType;
    StartDate: Date;
    EndDate: Date;
    CompletionStatus: TaskCompletionStatus;
    CompletionStatusDesc?: string | undefined;
    UserFacilityRoleID: number;
    DC_Date: Date;
    DC_By: number;
    DC_By_Name?: string | undefined;
    DC_Reason: number;
    DC_Reason_Desc?: string | undefined;
    DC_Reason_Note?: string | undefined;
    ModifiedBy: number;
    ModifiedOn: Date;
    isCompleteAllowed: boolean;
    IsOneTimeTask: boolean;
    ImmediateTaskIsComplete: boolean;
    FormattedStartDate?: string | undefined;
    FormattedEndDate?: string | undefined;
    SpanMultipleDays: boolean;
    LastCompletedOn?: string | undefined;
    LastCompletedByID: number;
    LastCompletedByName?: string | undefined;
    LastCompletedTaskDate: Date;
    LastCompletedNote?: string | undefined;
    LastCompletedNoteStatus?: string | undefined;
    CreatedBy: number;
    CreatedOn: Date;
    ActiveFlag?: string | undefined;
    TaskDueTodayFlag: boolean;
    TaskUnfinishedPreviousFlag: boolean;
    FormID: number;
    FilePath?: string | undefined;
    EntryDays: number;
    CreatedByName?: string | undefined;
    ATAStatusFlag: boolean;
    ATAStatusReason?: string | undefined;
    FirstOccurrence: Date;
    LastOccurrence: Date;
    DOB: Date;
    OMHLevel?: string | undefined;
    /** 12/13/2018:  This is used for keeping track of the appointment that's scheduled from this task (used on the "blue clock icon" page).
This gets set in the originating task, after the new appointment is created/added. */
    ScheduledTaskID: number;
    /** 12/13/2018:  This is used for keeping track of the originating task that created this appointment (used on the "blue clock icon" page). */
    OriginatingTaskID: number;
    MostRecentUncompletedDate: Date;
    TemplateID: number;
    HasAuditLogEntries: boolean;
    LastStatusIconColor?: string | undefined;
    HasAddedForm: boolean;
    KioskIssueID: number;
    TechFriendsWorkflow: number;
    KioskTypeID: KioskType;
}

export enum TaskPriority {
    Follow_Up = 1,
    Routine = 2,
    Priority = 3,
}

export enum TaskFrequencyType {
    None = 0,
    Quick = 1,
    Daily = 2,
    Weekly = 3,
    Monthly = 4,
    Yearly = 5,
    Immediate = 6,
    SpecificDates = 7,
}

export enum EndDateType {
    NoEndDate = 0,
    NumberOfOccurrences = 1,
    SpecificDate = 2,
}

export enum TaskCompletionStatus {
    Active = 0,
    Addressed = 1,
    Inactive = 2,
}

export enum KioskType {
    None = 0,
    TechFriends = 1,
    TurnKey = 2,
}

export interface TaskRoles {
    RoleID: number;
    RoleName?: string | undefined;
    Active: boolean;
}

export interface DentalCondition {
    Session_Date: Date;
    FormattedSessionDate?: string | undefined;
    ID: number;
    Symbol?: string | undefined;
    ConditionTypeName?: string | undefined;
    SessionID: number;
    patientID: number;
    PatientName?: string | undefined;
    PatientLocation?: string | undefined;
    PatientNumber?: string | undefined;
    PatientStatus?: string | undefined;
    waitlistID: number;
    treatmentStatusID: number;
    TreatmentName?: string | undefined;
    ToothName?: string | undefined;
    ToothID: number;
    waitlistTreatmentID: number;
    diagnosisID: number;
    LocID: number;
    LOC_Desc?: string | undefined;
    waitlistProcedureID: number;
    ProcedureType?: string | undefined;
    DC_Date: Date;
    DC_By?: string | undefined;
    DC_Reason: number;
    DCReasonByName?: string | undefined;
    DC_Reason_Note?: string | undefined;
    ModifiedBy: number;
    ModifiedOn: Date;
    CreatedBy: number;
    CreatedOn: Date;
    CreatedByName?: string | undefined;
    isPreExisting: boolean;
    LogType: DentalLogFilterType;
    TopOfToothFlag: boolean;
    SurfaceLookupList?: string[] | undefined;
}

export enum DentalLogFilterType {
    All = 0,
    PreExisting = 1,
    OnWaitlist = 2,
    CompletedTreatment = 3,
    Inactive = 4,
    Condition = 5,
}

export interface DentalConditionType {
    ID: number;
    Symbol?: string | undefined;
    ConditionTypeName?: string | undefined;
    TopOfToothFlag: boolean;
    SurfaceLookupList?: string[] | undefined;
}

export interface DentalLog {
    IsSelected: boolean;
    LogType: DentalLogFilterType;
    ItemStatus: DentalLogStatus;
    LogTypeName?: string | undefined;
    LogItemDate: Date;
    FormattedCreateDate?: string | undefined;
    ID: number;
    dentalTypeID: number;
    Condition: KeyValuePairOfIntegerAndString;
    ConditionID: number;
    sessionID: number;
    patientID: number;
    PatientName?: string | undefined;
    PatientLocation?: string | undefined;
    PatientNumber?: string | undefined;
    PatientStatus?: string | undefined;
    waitlistID: number;
    treatmentStatusID: number;
    ToothName?: string | undefined;
    toothID: number;
    selectedTeeth?: KeyValuePairOfIntegerAndString[] | undefined;
    Loc: KeyValuePairOfIntegerAndString;
    diagnosisID: number;
    LocID: number;
    LOC_Desc?: string | undefined;
    waitlistProcedureID: number;
    ProcedureType?: string | undefined;
    ModifiedBy: number;
    ModifiedOn: Date;
    CreatedBy: number;
    CreatedOn: Date;
    CreatedByName?: string | undefined;
    DC_Date: Date;
    DC_By?: string | undefined;
    DCReasonByName?: string | undefined;
    DC_Reason_Note?: string | undefined;
    ToothNotations?: string | undefined;
    waitlistTreatment?: WaitlistTreatment | undefined;
    selectedTreatments?: WaitlistTreatment[] | undefined;
    _rowVariant?: string | undefined;
    ToothMarkings?: DentalToothMarkings | undefined;
    Stamp?: string | undefined;
}

export enum DentalLogStatus {
    PreExisting = 1,
    NewWaitlist = 2,
    CompleteTreatment = 3,
    CompleteWaitlist = 4,
    Condition = 5,
}

export interface WaitlistTreatment {
    ID: number;
    NAME?: string | undefined;
    TopOfToothFlag: boolean;
    CommonFlag: boolean;
    DefaultToothID: number;
    DefaultLoc: KeyValuePairOfIntegerAndString;
}

export interface DentalToothMarkings {
    Session_Date: Date;
    FormattedSessionDate?: string | undefined;
    ID: number;
    WaitlistID: number;
    DentalTreatmentID: number;
    patientID: number;
    ToothID: number;
    RightInfo?: DentalToothMarkingInfo | undefined;
    LeftInfo?: DentalToothMarkingInfo | undefined;
    TopInfo?: DentalToothMarkingInfo | undefined;
    BottomInfo?: DentalToothMarkingInfo | undefined;
    CenterInfo?: DentalToothMarkingInfo | undefined;
    InactiveFlag: boolean;
}

export interface DentalToothMarkingInfo {
    TreatmentName?: string | undefined;
    StatusID: number;
    AssocDate: Date;
    SurfaceLookup: DentalSurfaceLookup;
}

export enum DentalSurfaceLookup {
    Mesial = 1,
    Occlusal = 2,
    Distal = 3,
    Lingual = 4,
    Buccal = 5,
    Facial = 6,
    Incisal = 7,
}

export interface DentalToothNote {
    ID: number;
    patientID: number;
    ToothName?: string | undefined;
    ToothID: number;
    Note?: string | undefined;
    Active: boolean;
    CreatedBy: number;
    CreatedOn: Date;
    CreatedByName?: string | undefined;
}

export interface DentalTreatment {
    Session_Date: Date;
    FormattedSessionDate?: string | undefined;
    ID: number;
    SessionID: number;
    patientID: number;
    PatientName?: string | undefined;
    PatientLocation?: string | undefined;
    PatientNumber?: string | undefined;
    PatientStatus?: string | undefined;
    waitlistID: number;
    treatmentStatusID: number;
    TreatmentName?: string | undefined;
    ToothName?: string | undefined;
    toothID: number;
    waitlistTreatmentID: number;
    diagnosisID: number;
    LocID: number;
    LOC_Desc?: string | undefined;
    waitlistProcedureID: number;
    ProcedureList?: string | undefined;
    DC_Date: Date;
    DC_By?: string | undefined;
    DC_Reason: number;
    DCReasonByName?: string | undefined;
    DC_Reason_Note?: string | undefined;
    ModifiedBy: number;
    ModifiedOn: Date;
    CreatedBy: number;
    CreatedOn: Date;
    CreatedByName?: string | undefined;
    isPreExisting: boolean;
}

/** Collection of facility settings. */
export interface FacilityProperties {
    ID: number;
    Name?: string | undefined;
    DCODE?: string | undefined;
    FacilityCutType: FacilityCutType;
    DefaultPRNFillDays: number;
    DefaultFillDays: number;
    DefaultDaysSupply?: number[] | undefined;
    AverageLeadTime: number;
    CardStockOnly: boolean;
    DistributionType: DistributionType;
    Licence_Flag: boolean;
    DEA_Licence_Flag: boolean;
    Control_Liability: boolean;
    Stock_Liability: boolean;
    Distribution_Override_Flag: boolean;
    MinimumReorderTimeWindow: number;
    CanShowRefillTooSoon: boolean;
    RefillWindow: number;
    ContactDiamondForBackup: boolean;
    MinimumRefillTimeWindow: number;
    CutTime: string;
    DeliveryMethod: DeliveryMethod;
    NoShipFriday: boolean;
    RefillCutTime: string;
    RequiresOrderVerification: boolean;
    ApprovalScope: ApprovalScope;
    NonFormularySettings?: NonFormularySettings | undefined;
    MaximumDaysSupply: number;
    ShippingAddress1?: string | undefined;
    ShippingAddress2?: string | undefined;
    BillingAddress1?: string | undefined;
    BillingAddress2?: string | undefined;
    ShippingCity?: string | undefined;
    BillingCity?: string | undefined;
    ShippingState?: string | undefined;
    BillingState?: string | undefined;
    ShippingZip?: string | undefined;
    BillingZip?: string | undefined;
    ContactName?: string | undefined;
    EMail?: string | undefined;
    ShippingPhone?: string | undefined;
    BillingPhone?: string | undefined;
    ShippingFax?: string | undefined;
    BillingFax?: string | undefined;
    CanDestroyNonControlledStockMed: boolean;
    CanDestroyControlledStockMed: boolean;
    CanDestroyNonControlledPatientMed: boolean;
    CanDestroyControlledPatientMed: boolean;
    ControlledMedDesrtuctionMustBeOffsite: boolean;
    VerifyControlledInventoryMustBeApprovedbyPharmacist: boolean;
    ControlledMedDesrtuctionMustBeApprovedbyPharmacist: boolean;
    CanAdministerOnCutDate: boolean;
    AllNewOrders: boolean;
    ShowDrugImageOnMedpass: boolean;
    MedpassSorting: number;
    PatientIdentifier: PatientIdentifierOptions;
    RequireUniquePatientIdentifier: boolean;
    BarcodeContent: BarcodeContentOptions;
    RequirePRNReason: boolean;
    DiscontinuedOrderDisplayDaysOnMedpass: number;
    MaxMedpassComplianceAdministrations: number;
    LocationLabel: LabelLocation;
    MedicationDestructionVendor?: string | undefined;
    AllowCabDelivery: boolean;
    AllowChargeAccountChanges: boolean;
    UnitAlias?: string | undefined;
    RoomAlias?: string | undefined;
    WingAlias?: string | undefined;
    BedAlias?: string | undefined;
    PROGRAM_ID1_Alias?: string | undefined;
    PROGRAM_ID2_Alias?: string | undefined;
    PROGRAM_ID3_Alias?: string | undefined;
    PROGRAM_ID4_Alias?: string | undefined;
    PROGRAM_ID5_Alias?: string | undefined;
    DefaultTimes?: FacilityTime[] | undefined;
    Schedules?: Frequency[] | undefined;
    ScheduleTimeAssociation?: FrequencyTimes[] | undefined;
    InterfaceSettings?: FacilityInterfaceSettings | undefined;
    CrushMedications?: DrugItem[] | undefined;
    ControlledMedications?: DrugItem[] | undefined;
    KOPMedications?: DrugItem[] | undefined;
    ProfileOnlyMedications?: DrugItem[] | undefined;
    OTCMedications?: DrugItem[] | undefined;
    MedpassOTCMedications?: DrugItem[] | undefined;
    PrnReasons?: string[] | undefined;
    InventoryAdjustmentReasons?: string[] | undefined;
    NonFormularyReasons?: string[] | undefined;
    DiscontinueOrderReasons?: string[] | undefined;
    MedpassMedicationIssues?: string[] | undefined;
    MedpassPatientRefusalReasons?: string[] | undefined;
    MedpassAbsentReasons?: string[] | undefined;
    ATAReasons?: string[] | undefined;
    LastModifiedByName?: string | undefined;
    LastModifiedDate: Date;
    CopyBillingAddressFlag: boolean;
    MaxDaysToDisplayOTCAdministrations: number;
    NotifyNFRequestToHigherTiers: boolean;
    ChargeAccountID: number;
    TimeZone: TimeZoneType;
    TimeFormat: TimeFormatType;
    DCOrdersOnTransfer: boolean;
    treatKOPAsUnscheduled: boolean;
    IsDiagnosisRequired: boolean;
    ExcludedFacilities?: FacilityDCExclusion[] | undefined;
    DisableAllAdministered: boolean;
    MedpassMissedItemsStartDate: Date;
    NonformularyTemplatePath?: string | undefined;
    MaxNFDaysSupply: number;
    ReleaseMedMaxDaysSupply: number;
    OtcAdministrationReasons?: string[] | undefined;
    MedpassHeldReasons?: string[] | undefined;
    EnableRecentDirections: boolean;
    Restrictions?: number[] | undefined;
    DiscontinueOrdersOnPatientRelease: boolean;
    BackupExempt: boolean;
    EnablePatVisits: boolean;
    EnablePatDocuments: boolean;
    EnableTasking: boolean;
    EnableDental: boolean;
    EnablePatLabs: boolean;
    AllowNonDiamondReturns: boolean;
    NeedsReviewedOnPatientTransfer: boolean;
    StartOnCheckin: boolean;
    PRNType: PRNType;
    CanPrintLabels: boolean;
    PatientDemoWebservice?: string | undefined;
    MaxBackupDays: number;
    SetScheduleExceptionOnXfer: boolean;
    DisabledAOCQueue: boolean;
    DisabledDCSignoffQueue: boolean;
    DisabledVitalQueueDCSignoff: boolean;
    DisabledVitalResultsSignoff: boolean;
    RequireOrderNotes: boolean;
    RequireInjectionSites: boolean;
    ShowShortTermsOrdersInRenewQueue: boolean;
    ProfileAllMedications: boolean;
    MedicationProfileOnly: boolean;
    IsInterfaced: boolean;
    ScreeningAllergies: boolean;
    ScreeningPLAG: boolean;
    ScreeningDose: boolean;
    ScreeningDrugToDrug: boolean;
    UserMessagingEnabled: boolean;
    PatientImmunizationsEnabled: boolean;
    AllowStockAdministration: boolean;
    ShowApproveAllInQueues: boolean;
    TARPASSEnabled: boolean;
    SummaryChartViewEnabled: boolean;
    PatientActivityRestrictionsEnabled: boolean;
    IsCipsInterfaced: boolean;
    ShowPricing: boolean;
    HasEPCS: boolean;
    EnableUM: boolean;
    EnablePatLists: boolean;
    EnableMultipleDashboards: boolean;
    EnableTBTest: boolean;
    EnableLabReview: boolean;
    DisablePatRestrictionsSignoff: boolean;
    DisablePatRestrictionsFollowUp: boolean;
    RequireVitalOrderFollowup: boolean;
    ShowUnscheduledKOPsOnActiveTab: boolean;
    EnablePrintWNLQueue: boolean;
    ExternalPharmacy: boolean;
    ForceTwoFacAuth: boolean;
    AmionLoginID?: string | undefined;
    UseNewMedpass: boolean;
    EnablePdmpInterface: boolean;
    EnableInboundImmunizations: boolean;
    EnableSurescripts: boolean;
    EnableRequiredDocumentTemplate: boolean;
    EnableRequiredAppointmentTemplate: boolean;
}

/** Facility categories based on the cut-type */
export enum FacilityCutType {
    None = 0,
    SoftCut = 1,
    HardCut = 2,
    Refill = 3,
    Retail = 4,
}

/** This enumeration represents facility setting of Distribution Type based on which the drugs that can be selected for STOCK ORDER would be restricted */
export enum DistributionType {
    None = 0,
    ForceDistribution = 1,
    NoStock = 2,
    DistibutionNotAllowed = 3,
    AllowDistribution = 4,
}

/** Represents the method of delivery for the order. */
export enum DeliveryMethod {
    Other = 0,
    Diamond = 1,
}

/** List of ApprovalScope */
export enum ApprovalScope {
    None = 0,
    ByScript = 1,
    ByGpi = 2,
}

export interface NonFormularySettings {
    ApprovalLevel: ApprovalLevel;
    MaxDaysSupply: number;
    DispenseDaysSupply: number;
    GPILength: number;
}

export enum ApprovalLevel {
    Exempt = 1,
    GpiForPatient = 2,
    GpiForPatientWithDateRange = 3,
    Order = 4,
    OrderWithDateRange = 5,
    GpiAndDirectionsWithDateRange = 6,
}

export enum PatientIdentifierOptions {
    None = 0,
    BillingNumber = 1,
    Number = 2,
    BarcodeNumber = 3,
}

export enum BarcodeContentOptions {
    None = 0,
    BillingNumber = 1,
    Number = 2,
    BarcodeNumber = 3,
}

export enum LabelLocation {
    None = 0,
    Unit = 1,
    Wing = 2,
    Room = 3,
    Bed = 4,
}

export interface FacilityTime {
    Name?: string | undefined;
    Time?: string | undefined;
}

export interface Frequency {
    ID: number;
    Name?: string | undefined;
    ExpandedName?: string | undefined;
    SynonymID: number;
    LabelFlag: boolean;
    TimesPerDay: number;
    FacilityID: number;
    Treatment: boolean;
}

export interface FrequencyTimes {
    Frequency?: string | undefined;
    AssociatedTimes?: string[] | undefined;
    TimesPerDay: number;
    SystemDefinedFrequency: boolean;
    Treatment: boolean;
}

export interface FacilityInterfaceSettings {
    InboundEnabled: boolean;
    OutboundEnabled: boolean;
    LabReportsInbound: boolean;
    LabINFUrlOutbound?: string | undefined;
    LabOrdersOutbound: boolean;
    MedsCancelsOutbound: boolean;
    MedsDiscontinuesOutbound: boolean;
    MedsFillsAndDispensesOutbound: boolean;
    MedsNewOrdersOutbound: boolean;
    MedsStatusChangesOutbound: boolean;
    MedsVoidsOutbound: boolean;
    PatientAddsOutbound: boolean;
    PatientUpdatesOutbound: boolean;
    UnsolicitedVitalsAndLabsOutbound: boolean;
    ImagingOrdersOutbound: boolean;
    UMApproval: boolean;
    UMAuth: boolean;
    UMConsultCompleteOrCanceled: boolean;
    OutboundLabCompendium: number;
    OutboundImagingCompendium: number;
    FacilityUsesManualEntryLabResults: boolean;
    LabFacAccount?: string | undefined;
    LabVendorMSHSegment?: string | undefined;
    ImagingFacAccount?: string | undefined;
    LabFacOutboundFolder?: string | undefined;
    ImagingFacOutboundFolder?: string | undefined;
    SendingLabFacility?: string | undefined;
    SendingLabApplication?: string | undefined;
    SendingImageFacility?: string | undefined;
    SendingImageApplication?: string | undefined;
}

export interface DrugItem {
    DrugId: number;
    DrugName?: string | undefined;
    GPI?: string | undefined;
    NDC?: string | undefined;
}

export enum TimeZoneType {
    None = 0,
    AST = 1,
    EST = 2,
    CST = 3,
    MST = 4,
    PST = 5,
    AKST = 6,
}

export enum TimeFormatType {
    None = 0,
    Standard = 43,
    Military = 44,
}

export interface FacilityDCExclusion {
    /** Gets or sets the facility id. */
    FacilityId: number;
    /** Gets or sets the facility name. */
    FacilityName?: string | undefined;
}

export enum PRNType {
    None = 0,
    NON = 1,
    SCHD = 2,
}

export interface FormUserType {
    ID: number;
    NAME?: string | undefined;
    DESCRIPTION?: string | undefined;
    ACTIVE: boolean;
    FAC_ID: number;
    FAC_GRP_ID: number;
}

export interface Hotlist {
    id: number;
    patientID: number;
    hotlistTypeID: number;
    hotlistReasonID: number;
    startedByUserID: number;
    stoppedByUserID: number;
    startDate: Date;
    stopDate?: Date | undefined;
    endDate?: Date | undefined;
    startDateDisplay?: string | undefined;
    stopDateDisplay?: string | undefined;
    endDateDisplay?: string | undefined;
    initialComment?: string | undefined;
    mostRecentComment?: string | undefined;
    active: boolean;
    comments?: HotlistComment[] | undefined;
    hotlistTypeName?: string | undefined;
    hotlistReasonName?: string | undefined;
    startedByUserFullName?: string | undefined;
    stoppedByUserFullName?: string | undefined;
    patientFullName?: string | undefined;
    hotlistIcon?: string | undefined;
}

export interface HotlistComment {
    id: number;
    hotlistID: number;
    comment?: string | undefined;
    isDeleteComment: boolean;
    userID: number;
    dateCreated: Date;
    commenterFullName?: string | undefined;
    dateCreatedDisplay?: string | undefined;
}

export interface HotlistType {
    id: number;
    facilityGroupID: number;
    name?: string | undefined;
    description?: string | undefined;
    active: boolean;
    maximumCapacity: number;
    interval: number;
    tags?: string | undefined;
}

export interface LastViewedPatient {
    PatientID: number;
    PatientName?: string | undefined;
    VisitDate: Date;
}

export interface MessageSenderVM {
    _FileAttachmentList?: PatientDocumentFile[] | undefined;
    _MessageBody?: string | undefined;
    _MessageID: number;
    _MessageRecipients?: User[] | undefined;
    _MessageType: number;
    _PatientID: number;
    _PatientName?: string | undefined;
    _Priority: number;
    _ReplyToMessageID: number;
    _Subject?: string | undefined;
    _ThreadRootMessageID: number;
    _MessageMode: number;
}

export interface Patient {
    PatientChartIsLocked: boolean;
    LastViewed: Date;
    PatientRestrictions: number;
    FacPatient_ID?: string | undefined;
    /** Gets or sets the patient id */
    PatientID: number;
    /** Gets or sets the patient's first name */
    FirstName?: string | undefined;
    /** Gets\Sets Audit Log Id */
    AuditLogID: number;
    /** Gets or sets the patient's middle name */
    MiddleName?: string | undefined;
    /** Gets or sets the patient's last name */
    LastName?: string | undefined;
    /** Gets or sets the full name of the patient */
    FullName?: string | undefined;
    /** Gets or sets the patient's date of birth */
    DOB: Date;
    /** Gets or sets the patient's date of birth */
    FormattedDOB?: string | undefined;
    /** Gets or sets the patient's ReleaseDate */
    ReleaseDate: Date;
    /** Gets or sets the patient's ReleaseDate */
    BookingDate: Date;
    /** gets or sets the CIPS pat id. */
    CipsPatId: number;
    /** gets / sets the booking no. */
    Number?: string | undefined;
    /** gets / sets the SSN number in the format "111-11-1111" */
    SSNumber?: string | undefined;
    /** gets / sets the gender of the patient. */
    Gender?: string | undefined;
    /** gets / sets the location. */
    Location?: string | undefined;
    /** gets / sets the unit. */
    Unit?: string | undefined;
    /** gets /sets the wing. */
    Wing?: string | undefined;
    /** get/sets the height of the patient in Feet. */
    HeightFt: number;
    /** get/sets the height of the patient in inches. */
    HeightInches: number;
    /** gets/ sets the weight. */
    Weight: number;
    /** gets / sets the weighdate */
    WeighDate: Date;
    /** gets / sets the address of the patient. */
    Address1?: string | undefined;
    /** gets / sets the address. */
    Address2?: string | undefined;
    /** gets / sets the city. */
    City?: string | undefined;
    /** gets / sets the phone number. */
    Phone?: string | undefined;
    /** gets / sets the email address. */
    Email?: string | undefined;
    /** gets / sets the state */
    State?: string | undefined;
    /** gets / sets the zip code. */
    Zip?: string | undefined;
    /** get/sets the Medical Hold Flag for the Patient */
    MedicalHoldFlag: boolean;
    UseOfForceFlag: number;
    IndigentFlag: boolean;
    ForeignBodySwallowerFlag: boolean;
    LifeSustainingMedsFlag: boolean;
    DisabilityFlag: boolean;
    DrugTreatmentFlag: boolean;
    /** Decides whether a patient is eligible for KOP */
    SelfCarryFlag: boolean;
    /** Decides whether a patient is on suicide watch */
    SuicideWatch?: string | undefined;
    /** Gets / sets the masked ssn in the format "XXX-XX-1111". */
    MaskedSSN?: string | undefined;
    /** Gets or sets the value for the DTYPE (ie) Patient (F) / Protocol (P) / Standard Order (S) / Stock (T) */
    DType?: string | undefined;
    /** Gets / sets teh facility id. */
    FacilityId: number;
    /** Gets / sets the facility formatted as ‘FAC.DCODE + ‘ – ‘ + FAC.DNAME’ */
    FormattedFacility?: string | undefined;
    /** gets / sets agency */
    Agency?: string | undefined;
    /** gets or sets the patient allergies */
    Allergies?: IAllergyType[] | undefined;
    /** gets or sets the patient aliases */
    Aliases?: string | undefined;
    /** gets or sets the patient race */
    Race?: string | undefined;
    /** gets or sets the patient secondary races */
    SecondaryRace?: { [key: string]: string; } | undefined;
    /** gets or sets the patient pronouns */
    Pronouns?: { [key: string]: string; } | undefined;
    /** gets or sets the patient ethnicity */
    Ethnicity?: string | undefined;
    /** gets or sets the patient secondary ethnicity */
    SecondaryEthnicity?: string | undefined;
    /** gets or sets the patient smoking status */
    Smoking?: string | undefined;
    /** gets or sets the patient country */
    Country: number;
    /** gets or sets the patient language */
    Language?: string | undefined;
    /** gets or sets the patient status */
    Status?: string | undefined;
    /** gets or sets the patient's bed number */
    Bed?: string | undefined;
    /** gets or sets the patient's room number */
    Room?: string | undefined;
    /** gets or sets the patient's body surface */
    BodySurface: number;
    /** gets or sets the patient's creatin */
    Creatin: number;
    /** gets or sets the patient's OMH level */
    OMHLevel?: string | undefined;
    /** gets or sets the patient's IQ */
    IQ: number;
    /** gets or sets the patient's IQ Category */
    IQCategory?: string | undefined;
    /** gets or sets the patient's Sexual Orientation */
    SexualOrientation?: string | undefined;
    /** gets or sets the patient's Gender Identity */
    GenderIdentity?: string | undefined;
    /** gets or sets the patient's INR goal */
    GoalINR?: string | undefined;
    /** Decides whether a patient is visible within system */
    DisplayFlag: boolean;
    /** Decides whether a patient is pregnant */
    PregnantFlag: boolean;
    /** Decides whether a patient is lactating */
    LactationFlag: boolean;
    /** gets or sets the charge account id for the patient */
    CHGID: number;
    /** gets or sets the charge account id for the patient */
    CHGName?: string | undefined;
    ChargeAccountFacilityID: number;
    PrescriberID: number;
    /** Gets or sets the prescriber name. */
    PrescriberName?: string | undefined;
    /** gets or sets the name of the user who created the patient record */
    CreatedBy: number;
    /** gets or sets the inmate number for the patient */
    AltNumber?: string | undefined;
    /** gets or sets the barcode number for the patient */
    BarcodeNumber?: string | undefined;
    /** gets or sets the patient image identifier */
    ImageIdentifier: string;
    /** Gets or sets the last modified by id. */
    LastModifiedBy: number;
    /** Gets or sets the last modified by name. */
    LastModifiedByName?: string | undefined;
    /** Gets or sets the last modified date. */
    LastModifiedDate: Date;
    /** Gets or Sets LastEventID */
    LastEventID: EventType;
    /** Gets/Sets the patient's crush flag */
    CrushFlag: boolean;
    /** Gets/Sets the patient's allergy flag */
    HasAllergies: boolean;
    /** Gets or sets the patient's grouping */
    Grouping?: string | undefined;
    /** Gets/Sets the patient's safetty cap flag */
    SafetyCapFlag: boolean;
    Diagnosis?: Diagnosis[] | undefined;
    PatientIdentifier?: string | undefined;
    ATAFlag: boolean;
    Notes?: string | undefined;
    nf_exempt_date: Date;
    CreatedOn: Date;
    CrushMeds: boolean;
    ProgramID1?: string | undefined;
    ProgramID2?: string | undefined;
    ProgramID3?: string | undefined;
    ProgramID4?: string | undefined;
    ProgramID5?: string | undefined;
    AnniversaryDate: Date;
    MinDate: Date;
    MaxDate: Date;
    EnableHeaderLink: boolean;
    SessionViewedOn: Date;
    IsActivePatient: boolean;
    OrderType?: string | undefined;
    matchResults?: string | undefined;
    Insurer?: PatientInsurer | undefined;
}

export interface IAllergyType {
    AllergyID: number;
    AllergyName?: string | undefined;
    AllergyType?: string | undefined;
    AllergySeverity?: string | undefined;
    AllergyOnsetType?: string | undefined;
    AllergyOnsetDate: Date;
    IsMedicationalAllergy: boolean;
}

export interface Diagnosis {
    FormattedDisplayName?: string | undefined;
    DeletedFlag: boolean;
    DeletedBy?: string | undefined;
    ActiveFlag: boolean;
    ID: number;
    PatDiagnosisID: number;
    DiagnosisID: number;
    DiagnosisParentID?: string | undefined;
    Code?: string | undefined;
    Description?: string | undefined;
    LongDescription?: string | undefined;
    ShortDescription?: string | undefined;
    DescriptionFormatted?: string | undefined;
    StartOn: Date;
    StopOn: Date;
    DiagnosedBy_DOC?: string | undefined;
    DiagnosedBy_USER?: string | undefined;
    ResolvedBy?: string | undefined;
    PatientID: number;
    isUncoded: boolean;
    DiagnosisType: DiagnosisType;
    DiagnosisCodeSet?: string | undefined;
    DiagnosisCodeSetID: number;
    OrderID: number;
    Tags?: string | undefined;
    ModifiedByUserID: number;
    isIntakeDiagnosis: boolean;
    DeletedReason?: string | undefined;
    CodeSetColor?: string | undefined;
    /** Do not prepopulate on Modify Order. This field is used for adding new notes only. Notes will not duplicate because Existing notes will not be loaded with a populated Note Field (This will be null and skiped)
DEV NOTE: At some point may want toadd a field UpdateNote to avoid confusion. */
    Notes?: string | undefined;
    HasNotes: boolean;
    FormattedStartDateShortDate?: string | undefined;
    FormattedStopDateShortDate?: string | undefined;
    ResolveReason?: string | undefined;
}

export enum DiagnosisType {
    NONE = 0,
    CHRONIC = 1,
    ACUTE = 2,
    NA = 3,
    HISTORY = 4,
    PROVISIONAL = 5,
}

export interface PatientInsurer {
    ID: number;
    PatientID: number;
    InsurerNamePrimary?: string | undefined;
    PolicyNumberPrimary?: string | undefined;
    GroupNumberPrimary?: string | undefined;
    PharmacyNamePrimary?: string | undefined;
    EffectiveDatePrimary: Date;
    CancelationDatePrimary: Date;
    InsurerNameSecondary?: string | undefined;
    PolicyNumberSecondary?: string | undefined;
    GroupNumberSecondary?: string | undefined;
    PharmacyNameSecondary?: string | undefined;
    EffectiveDateSecondary: Date;
    CancelationDateSecondary: Date;
}

export interface PatientAlertVM {
    ID: number;
    PatientId: number;
    AlertType: number;
    AlertText?: string | undefined;
    CreatedByUserName?: string | undefined;
    CreatedOnDisplay?: string | undefined;
    Deleted: boolean;
    LastModifiedByUserName?: string | undefined;
    LastModifiedOnDisplay?: string | undefined;
}

export interface PatientForm {
    ID: number;
    ParentID: number;
    PatientID: number;
    PatientName?: string | undefined;
    PatientStatus?: string | undefined;
    PatientGender?: string | undefined;
    PatientNumber?: string | undefined;
    isSignoffNeeded: boolean;
    isSignoffCompleted: boolean;
    isSignoffDeclined: boolean;
    FacilityID: number;
    FacilityName?: string | undefined;
    Name?: string | undefined;
    FacilityRegionID: number;
    DCode?: string | undefined;
    Description?: string | undefined;
    CategoryID: number;
    CategoryName?: string | undefined;
    ProviderID: number;
    ProviderName?: string | undefined;
    CreatedBy?: string | undefined;
    CreatedOn: Date;
    FormattedCreatedOn?: string | undefined;
    ModifiedBy?: string | undefined;
    ModifiedOn: Date;
    SignedBy?: string | undefined;
    SignedByID: number;
    SignedOn: Date;
    PatientDOB: Date;
    AuditLogID: number;
    InactiveFlag: boolean;
    Completed: boolean;
    FilePath?: string | undefined;
    FileName?: string | undefined;
    DC_Date: Date;
    DC_By: number;
    DC_Reason: number;
    Form_Type: number;
    FormUserTypeID: number;
    FormUserTypeName?: string | undefined;
    CategoryTags?: Tag[] | undefined;
    FormTagNames?: string | undefined;
    FormLoadString?: string | undefined;
    DocumentFileID: number;
    ParentResultID: number;
    ConsultRequestID: number;
    IsUserApprovalAllowed: boolean;
    PartialResponseRadPdfDocumentID: number;
    WorkingFilePath?: string | undefined;
    RequireSignature: boolean;
    RequiresSignoff: boolean;
    SignoffTemplateID: number;
    EnableOrdering: boolean;
    FacID: number;
    FacGroupID: number;
    FacilityGroupName?: string | undefined;
    PatientLocation?: string | undefined;
    SignoffDisplayText?: string | undefined;
    SignoffNote?: string | undefined;
    GroupName?: string | undefined;
    GroupID: number;
    Discontinued: boolean;
    FormResponseNotes?: FormResponseNotes[] | undefined;
    PatientDocumentNotes?: FormResponseNotes[] | undefined;
    RequireReferral: boolean;
    AllowFormFollowUps: boolean;
    CompleteTaskID: number;
    TaskDate: Date;
    isFileAttachments: boolean;
    NameUserCreateOn?: string | undefined;
    ECSObjectKeyPath?: string | undefined;
    HasTasks: boolean;
    HasReviewNotes: boolean;
    ReviewNotesToolTip?: string | undefined;
}

export interface PatientFormBasicInfo {
    ID: number;
    ParentID: number;
    PatientID: number;
    Name?: string | undefined;
    DCode?: string | undefined;
    CategoryName?: string | undefined;
    InactiveFlag: boolean;
    FilePath?: string | undefined;
    Form_Type: number;
    FormUserTypeID: number;
    FormUserTypeName?: string | undefined;
    CategoryTags?: Tag[] | undefined;
    OpenFormURL?: string | undefined;
    PrintFormURL?: string | undefined;
    PrintFormNoPatientURL?: string | undefined;
    CreatedDate: Date;
}

export interface Prescriber {
    /** Represents ID of Prescriber  */
    PrescriberID: number;
    /** Represents the name of the Prescriber  */
    PrescriberName?: string | undefined;
    DEA?: string | undefined;
    FirstName?: string | undefined;
    LastName?: string | undefined;
    Degree?: string | undefined;
    Address1?: string | undefined;
    Address2?: string | undefined;
    City?: string | undefined;
    State?: string | undefined;
    Zip?: string | undefined;
    Phone?: string | undefined;
    Fax?: string | undefined;
    State_Num?: string | undefined;
    DEA_Exp: Date;
    State_Num_Exp: Date;
    NPI?: string | undefined;
    XNumber?: string | undefined;
    NameAndDEA?: string | undefined;
}

export interface ProgressNoteSummaryTS {
    ID: number;
    Name?: string | undefined;
    Description?: string | undefined;
    SignedBy?: string | undefined;
    SignedDate: Date;
    SignedDateDisplay?: string | undefined;
    CreatedBy?: string | undefined;
    CreatedDate: Date;
    CreatedDateTimeDisplay?: string | undefined;
    IsDynamicForm: boolean;
    IsStaticForm: boolean;
    IsDocument: boolean;
    IsProgressNote: boolean;
    IsCritical: boolean;
    FileName?: string | undefined;
    FilePath?: string | undefined;
    DocFileID: number;
    DocType?: string | undefined;
    FormViewerURL?: string | undefined;
    DownloadDynamicFormURL?: string | undefined;
    DownloadRedactedDynamicFormURL?: string | undefined;
    DownloadDocumentURL?: string | undefined;
    DocFileCount: number;
    TemplateID: number;
    LaunchNewFormURL?: string | undefined;
    FormTemplate?: PatientFormBasicInfo | undefined;
    ProgressNoteDelimitedList?: string | undefined;
    FormUserTypeName?: string | undefined;
    ECSObjectKeyPath?: string | undefined;
    DataHint?: string | undefined;
}

export interface QueuesSummary {
    QueueID: number;
    QueueName?: string | undefined;
    QueueURL?: string | undefined;
    QueueCount: number;
    QueueType: number;
}

/** Reason DTO represents the information about the reason text and the reason category */
export interface Reason {
    /** Uniquely identifies each Reason */
    ReasonID: number;
    /** Represents the predefined reason */
    Reason?: string | undefined;
    /** Represents the reason category */
    ReasonCategory: ReasonCategory;
}

/** List of Reason Categories */
export enum ReasonCategory {
    None = 1,
    DiscontinueScript = 2,
    ProfileOrder = 3,
    PRN = 4,
    InventoryAdjustment = 5,
    NonFormularySelection = 6,
    MedpassMedicationIssues = 7,
    MedpassPatientRefusals = 8,
    MedpassAbsent = 9,
    RefillTooSoon = 10,
    Other = 11,
    DestroyLocations = 12,
    ATAReasons = 13,
    OtcAdministration = 14,
    HeldReasons = 15,
    DeletedDiagnosis = 16,
    ResolveDiagnosis = 17,
}

export interface TaskFilter {
    SavedName?: string | undefined;
    SavedDescription?: string | undefined;
    CannedDate: TaskFilterCannedDates;
    TaskFilterID: number;
    IsDefault: boolean;
    UserID: number;
    queueAction: TaskFilterQueueAction;
    PatientID: number;
    FacilityID: number;
    SortBy?: string | undefined;
    SortDirection: SortDirection;
    Tags?: Tag[] | undefined;
    TaskUsers?: User[] | undefined;
    FrequencyID: number;
    ShowMyTasks: boolean;
    ShowAlertTasks: boolean;
    ShowTasksDueToday: boolean;
    RoleID: number;
    SearchCriteria?: PatientSearchCriteria | undefined;
    PriorityIDs?: number[] | undefined;
    StatusIDs?: number[] | undefined;
    ReasonID: number;
    ShowCompletedTasks: boolean;
    TaskTitleSearch?: string | undefined;
    TaskPatientSearch?: string | undefined;
    DateFrom: Date;
    DateTo: Date;
    NoFilterCacheFlag: boolean;
    CategoryANDFlag: boolean;
}

export enum TaskFilterQueueAction {
    Filter = 0,
    Sort = 1,
    Page = 2,
    PageLoad = 3,
    ClosePopup = 4,
}

/** Represents the Sort Directions */
export enum SortDirection {
    Ascending = 0,
    Descending = 1,
}

export interface PatientSearchCriteria {
    Unit?: string | undefined;
    Wing?: string | undefined;
    Room?: string | undefined;
    Bed?: string | undefined;
    ShowInactive: boolean;
    ShowReleased: boolean;
    ShowTransfered: boolean;
    SearchMedications: boolean;
    SearchVitalsLabs: boolean;
    SearchText?: string | undefined;
    LastNameStartsWith?: string | undefined;
    PatientIdentifier: PatientIdentifierOptions;
    ShowPatientsAssignedToLoggedInPrescriber: boolean;
    SearchRegion: boolean;
    SearchDiagnosis: boolean;
    ShowKOP: boolean;
    ShowDOTCOT: boolean;
    SearchAllergies: boolean;
}

export interface UserDashboard {
    QueuesList?: number[] | undefined;
    UserID: number;
    QueuesCount?: QueuesSummary[] | undefined;
}

export interface UserSearchData {
    /** gets or sets UserID */
    UserID: number;
    /** gets or sets the UserName */
    UserName?: string | undefined;
    /** gets or sets the FirstName */
    FirstName?: string | undefined;
    /** gets or sets the LastName */
    LastName?: string | undefined;
    /** gets or sets the Facility */
    Facility?: string | undefined;
    /** gets or sets the Status */
    Status?: string | undefined;
    /** gets or sets the User Role */
    UserRole?: string | undefined;
    /** gets or sets the Locked */
    Locked: boolean;
    /** gets or sets the UserStatus */
    UserStatus: boolean;
    /** gets or sets the Locked */
    isMultiRegion: boolean;
    SSOEnabled: boolean;
    DocID: number;
    isEPCSApproved: boolean;
}

export interface Waitlist {
    ID: number;
    PatientID: number;
    ATAStatusFlag: boolean;
    ATAStatusReason?: string | undefined;
    Waitlist_Date: Date;
    FormattedWaitlistDate?: string | undefined;
    Procedure_LDS: Date;
    ProcedureList?: string | undefined;
    PatientName?: string | undefined;
    PatientLocation?: string | undefined;
    PatientNumber?: string | undefined;
    PatientStatus?: string | undefined;
    ToothName?: string | undefined;
    ToothID: number;
    TreatmentName?: string | undefined;
    TreatmentID: number;
    LOC: number;
    LOC_Desc?: string | undefined;
    CompletionStatus: TaskCompletionStatus;
    CompletionStatusDesc?: string | undefined;
    DC_Date: Date;
    DC_By?: string | undefined;
    DC_Reason: number;
    DCReasonByName?: string | undefined;
    DC_Reason_Note?: string | undefined;
    ModifiedBy: number;
    ModifiedOn: Date;
    Completion_Note?: string | undefined;
    isCompleteAllowed: boolean;
    CreatedBy: number;
    CreatedOn: Date;
    AuditLogID: number;
    ActiveFlag?: string | undefined;
    WaitlistOverdueFlag: boolean;
    CreatedByName?: string | undefined;
    CompletionDate: Date;
    CompletionByName?: string | undefined;
    CompletionReason?: string | undefined;
    /** 5/29/2019:  This is used for keeping track of the appointment that's scheduled from this waitlist (used on the "blue clock icon" page).
This gets set in the originating waitlist, after the new appointment is created/added. */
    ScheduledTaskID: number;
    AppointmentDate: Date;
    AppointmentTitle?: string | undefined;
    toothMarkings?: DentalToothMarkings | undefined;
}

export interface Waitlist_Detail {
    MasterWaitlist?: Waitlist | undefined;
    SpecificID?: string | undefined;
    TaskDate: Date;
    FormattedTaskDate?: string | undefined;
    Status?: string | undefined;
    StatusReasonID: number;
    StatusReasonDesc?: string | undefined;
    StatusReasonDescColor?: string | undefined;
    CompletedDate?: string | undefined;
    CompletedBy?: string | undefined;
    CompletedNote?: string | undefined;
    DateOfBirth?: string | undefined;
    /** Get/Set CompletedNotes */
    OMH?: string | undefined;
}

export interface WaitlistSurfaceTreatment {
    /** **************
  1= Amal
  2= Resin

  I'm leaving room for them to add more, after the initial kickoff.
**************
  */
    SurfaceTypeID: number;
    SurfaceID: number;
    SurfaceType?: string | undefined;
    Surface?: string | undefined;
    TreatmentID: number;
    TreatmentName?: string | undefined;
}

